import * as types from './types';

export const openQuickInfo = (payload) => ({
    type: types.OPEN_QUICK_INFO,
    payload: payload
});

export const closeQuickInfo = () => ({
    type: types.CLOSE_QUICK_INFO,
    payload: null
});
